var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('h2',[_vm._v("\n    This is\n    "),_c('h1',[_vm._v("Admin Panel")]),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("\n      LOGIN\n    ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }